import ReportingInProgress from './component.jsx'
export default ReportingInProgress
